module.exports = __webpack_public_path__ + "static/media/es-AR.1b145e05.svg";